import { render, staticRenderFns } from "./SetJxcParam.vue?vue&type=template&id=6145f4d9"
import script from "./SetJxcParam.vue?vue&type=script&lang=js"
export * from "./SetJxcParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports